import { useEffect, useState } from 'react';
import apiNet from '../../../../newApi/apiNet.ts';
import { PulseLoader } from '../../../loaders/PulseLoader.tsx';
import { INotification } from '../../../../interfaces/account/notification/INotification.ts';
import Markdown from 'react-markdown';

interface IProps {
    notification: INotification;
}

const AccountNotificationDetailsModalContent = ({ notification }: IProps) => {
    const [notificationDetails, setNotificationDetails] = useState<INotification | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        apiNet.getNotification(notification.id)
            .then(res => {
                console.log(res.data);
                setNotificationDetails(res.data);
            })
            .catch(err => {
                console.error(err);
                setError('Nie udało się pobrać danych');
            })
            .finally(() => setIsLoading(false));
    }, [notification.id]);

    if (isLoading) return <PulseLoader />;
    if (error) return <div className="text-red-400 p-4">{error}</div>;
    if (!notificationDetails) return <div>Brak danych</div>;

    return <div className={'mt-2'}>
        <Markdown components={{
            h2: props => (
                <h2 className="text-2xl font-bold text-neutral-100 mt-4 mb-3 px-3" {...props} />
            ),
            p: ({ children, ...props }) => {
                return <p className="px-3 mb-3 text-neutral-100" {...props}>{children}</p>;
            },
            img: props =>
                <img className="rounded-3xl my-4 max-w-full h-auto block" {...props} />,
        }}>
            {notificationDetails.body}
        </Markdown>
    </div>;
};


export default AccountNotificationDetailsModalContent;